import { Clock } from "lucide-react";
import './ProgressClass.css';
import { useEffect, useState } from "react";
import { teacherAPI } from '../../../api/aulasApi';

export default function ClassCard() {
    const [classData, setClassData] = useState(null);
    const [progressPercentage, setProgressPercentage] = useState(0);
    const [classStatusText, setClassStatusText] = useState("Carregando...");
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchClassData = async () => {
            try {
                setIsLoading(true);
                const response = await teacherAPI.getAulaToday();
                setClassData(response.data);
                setError(null);
            } catch (err) {
                setError(err.message || "Failed to fetch class data.");
                console.error("Error fetching class data:", err);
                setClassData(null);
            } finally {
                setIsLoading(false);
            }
        };

        fetchClassData();
    }, []);

    useEffect(() => {
        if (classData && classData.hora_inicio && classData.hora_fim) {
            const calculateStatusAndProgress = () => {
                const now = new Date();
                const [startHour, startMinute, startSecond] = classData.hora_inicio.split(':').map(Number);
                const [endHour, endMinute, endSecond] = classData.hora_fim.split(':').map(Number);

                const startTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), startHour, startMinute, startSecond);
                const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), endHour, endMinute, endSecond);

                let currentProgress = 0;
                let statusText = "";

                if (now < startTime) {
                    currentProgress = 0;
                    statusText = "Próxima aula";
                } else if (now > endTime) {
                    currentProgress = 100;
                    statusText = "Aula Concluída";
                } else {
                    const totalDuration = endTime.getTime() - startTime.getTime();
                    const elapsedTime = now.getTime() - startTime.getTime();
                    currentProgress = Math.min(100, Math.max(0, (elapsedTime / totalDuration) * 100));
                    statusText = "Aula em andamento";
                }
                setProgressPercentage(currentProgress);
                setClassStatusText(statusText);
            };

            calculateStatusAndProgress();
            const intervalId = setInterval(calculateStatusAndProgress, 60000);

            return () => clearInterval(intervalId);
        } else if (!isLoading && !error) {
            setClassStatusText("Nenhuma aula hoje.");
            setProgressPercentage(0);
        }
    }, [classData, isLoading, error]);

    if (isLoading) {
        return (
            <div className="ClassCard__card">
                <div className="ClassCard__header">
                    <div className="ClassCard__status-header">
                        <Clock className="ClassCard__clock-icon" size={20} />
                        <span className="ClassCard__status-text">Carregando aula...</span>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="ClassCard__card ClassCard__error">
                 <div className="ClassCard__header">
                    <div className="ClassCard__status-header">
                        <Clock className="ClassCard__clock-icon" size={20} />
                        <span className="ClassCard__status-text">Erro ao carregar</span>
                    </div>
                </div>
                <p className="ClassCard__error-text">Detalhe: {error}</p>
            </div>
        );
    }
    
    if (!classData && classStatusText === "Carregando...") {
         return (
            <div className="ClassCard__card">
                 <div className="ClassCard__header">
                    <div className="ClassCard__status-header">
                        <Clock className="ClassCard__clock-icon" size={20} />
                        <span className="ClassCard__status-text">Nenhuma aula programada.</span>
                    </div>
                </div>
            </div>
        );
    }


    const formattedStartTime = classData?.hora_inicio ? classData.hora_inicio.substring(0, 5) : "--:--";
    const formattedEndTime = classData?.hora_fim ? classData.hora_fim.substring(0, 5) : "--:--";

    return (
        <div className="ClassCard__card">
            <div className="ClassCard__header">
                <div className="ClassCard__status-header">
                    <Clock className="ClassCard__clock-icon" size={20} />
                    <span className="ClassCard__status-text">{classStatusText}</span>
                </div>

                {classData && (
                    <div className="ClassCard__class-info">
                        <h2 className="ClassCard__class-title">{classData.disciplina || "Disciplina não informada"}</h2>
                        <p className="ClassCard__class-subtitle">{classData.curso || "Curso não informado"}</p>
                    </div>
                )}
            </div>

            {classData && (
                <div className="ClassCard__time-section">
                    <div className="ClassCard__time-container">
                        <div className="ClassCard__time-block">
                            <span className="ClassCard__time-label">Início</span>
                            <span className="ClassCard__time-value">{formattedStartTime}</span>
                        </div>

                        <div className="ClassCard__progress-container">
                            <div className="ClassCard__progress-bar">
                                <div className="ClassCard__progress-fill" style={{ width: `${progressPercentage}%` }}></div>
                            </div>
                        </div>

                        <div className="ClassCard__time-block">
                            <span className="ClassCard__time-label">Término</span>
                            <span className="ClassCard__time-value">{formattedEndTime}</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}